import React from "react";
import { userProfile } from "#common";
import { ExtAuthProviderBtn } from "#glib/ui/component/misc/ExtAuthProviderBtn";
import { IApplicationContext } from "../context";

/**
 * SignupOptions
 */
export const SignupOptions: React.FunctionComponent<IApplicationContext> = (props) => {
	if (!(window as any).extAuth) return null;
	const { gauth, msauth, lauth } = (window as any).extAuth;

	console.log("Auth options", { gauth, msauth, lauth });

	/**
	 * Handle signup
	 * @param provider
	 * @param ev
	 */
	const onClick = (provider: userProfile.TProvider, ev: React.MouseEvent) => {
		ev.preventDefault();
		ev.stopPropagation();

		switch (provider) {
			case "google":
				props.api.goToExtAuth(gauth);
				break;

			case "microsoft":
				props.api.goToExtAuth(msauth);
				break;

			case "linkedin":
				props.api.goToExtAuth(lauth);
				break;
		}
	};

	return (
		<div className='auth-ext uk-margin-medium-top'>
			<div className='auth-providers'>
				{gauth ? <ExtAuthProviderBtn provider='google' text='Sign up with' onClick={onClick.bind(null, "google")} /> : null}
				{msauth ? <ExtAuthProviderBtn provider='microsoft' text='Sign up with' onClick={onClick.bind(null, "microsoft")} /> : null}
				{lauth ? <ExtAuthProviderBtn provider='linkedin' text='Sign up with' onClick={onClick.bind(null, "linkedin")} /> : null}
			</div>
		</div>
	);
};
